import React from 'react';
import classnames from 'classnames';
import { Spinner } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
  Route,
  RouteComponentProps,
  Switch,
  withRouter,
} from 'react-router-dom';

import angleIcon from 'v2/icons/angle.svg';
import styles from './datasetDetailsContainer.module.scss';
import DatasetDetail from './DatasetDetail';
import useHistoryBackState from 'v2/hooks/useHistoryBackState';
import { useTranslation } from 'react-i18next';
import { TranslationKeys, PostProcessKeys } from 'translations';
import InvalidDRMLinkMessage from 'v2/pages/DrmFeatures/Shared/InvalidDRMLinkMessage/InvalidDRMLinkMessage';
import { useDataProduct } from 'v2/queries/useDataProduct';

export type DatasetRouterProps = RouteComponentProps<{ id: string }>;

export const DatasetDetailsContainer = ({ match }: DatasetRouterProps) => {
  const { t } = useTranslation();
  const { path, params } = match;
  const { backLinkTitle: backLinkTitleFromState, goBackHistory } =
    useHistoryBackState('/data-sets/1');
  const backLinkTitle =
    backLinkTitleFromState ||
    t(TranslationKeys.dataProduct_other, {
      postProcess: PostProcessKeys.TitleCase,
    });

  const {
    data: dataset,
    isLoading: isDatasetLoading,
    isError: isDatasetError,
    refetch: refetchDataset,
  } = useDataProduct({ id: Number(params.id), cacheTime: 0, retry: false });

  if (isDatasetLoading) {
    return (
      <div className="loadingIndicatorContainer">
        <Spinner role="progressbar" animation="border" />
      </div>
    );
  }

  if (isDatasetError) {
    return <InvalidDRMLinkMessage />;
  }

  return (
    <div className={classnames('bg-white h-100')}>
      <div
        className={classnames(
          'd-flex',
          'justify-content-between',
          'bg-light',
          'position-relative',
          'z-index-1',
          'page-title'
        )}
      >
        <div className="container-xl d-flex justify-content-between position-relative fix-bg-images">
          <div
            className={classnames(
              'align-items-center text-truncate align-self-center',
              styles.header
            )}
          >
            <div
              data-cy="dataset:backlink-to-datasets-list-page"
              onClick={() => goBackHistory()}
              className={classnames(styles.prevLink, 'text-truncate')}
            >
              <img src={angleIcon} alt="angleIcon"></img>
              <h1
                className={classnames('m-0 text-truncate pr-1')}
                data-testid="go-back-title"
                data-cy={`dataset:${backLinkTitle.replaceAll(' ', '-')}`}
              >
                {backLinkTitle}
              </h1>
            </div>
            <div
              className={classnames('text-truncate', styles.title)}
              data-testid="header_name"
            >
              {dataset?.name}
            </div>
          </div>
        </div>
      </div>
      <div
        className={classnames(
          'bg-white h-100 px-4',
          styles.routeDetailContainer
        )}
      >
        {dataset && (
          <Switch>
            <Route path={`${path}/detail`}>
              <DatasetDetail dataset={dataset} refetch={refetchDataset} />
            </Route>
          </Switch>
        )}
      </div>
    </div>
  );
};

export default connect<DatasetRouterProps>(null)(
  withRouter(DatasetDetailsContainer)
);
